import { Notification, CreateNotificationData } from '../types/notification';

// Mock data
let mockNotifications: Notification[] = [
  {
    id: 1,
    title: 'System Maintenance',
    message: 'System will be under maintenance on Saturday, 10 PM to Sunday, 2 AM.',
    status: 'active',
    createdAt: '2024-03-15T10:00:00Z',
    updatedAt: '2024-03-15T10:00:00Z',
    deletedAt: null
  },
  {
    id: 2,
    title: 'New Feature Release',
    message: 'We have released new features for better locker management.',
    status: 'active',
    createdAt: '2024-03-14T15:30:00Z',
    updatedAt: '2024-03-14T15:30:00Z',
    deletedAt: null
  },
  {
    id: 3,
    title: 'Holiday Schedule',
    message: 'Our support team will have limited availability during the upcoming holidays.',
    status: 'active',
    createdAt: '2024-03-13T09:00:00Z',
    updatedAt: '2024-03-13T09:00:00Z',
    deletedAt: null
  }
];

export const getNotifications = async (): Promise<Notification[]> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  return mockNotifications;
};

export const createNotification = async (data: CreateNotificationData): Promise<Notification> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  const newNotification: Notification = {
    id: mockNotifications.length + 1,
    title: data.title,
    message: data.message,
    status: 'active',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null
  };

  mockNotifications.push(newNotification);
  return newNotification;
};

export const deleteNotification = async (id: number): Promise<void> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  mockNotifications = mockNotifications.filter(notification => notification.id !== id);
};

export const resendNotification = async (id: number): Promise<void> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  mockNotifications = mockNotifications.map(notification =>
    notification.id === id
      ? { ...notification, updatedAt: new Date().toISOString() }
      : notification
  );
};
